module.exports = "body {\n  margin: 0;\n  min-height: 100vh;\n  background: #eef4f8;\n  color: #142234;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.crypto-treemap-chart .highcharts-data-labels,\n.crypto-treemap-chart .highcharts-data-label {\n  pointer-events: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles